import type { App } from 'vue'

type DialogApi = {
  open: (options?: {
    data?: any
    attrs?: Record<string, any>
    options?: { bgClose?: boolean }
    onclose?: () => void
  }) => Promise<void>
  close: () => Promise<void>
  update: (data: Record<string, any>) => void
  confirm: (options?: {
    data?: any
    attrs?: Record<string, any>
    options?: { bgClose?: boolean }
    onclose?: () => void
  }) => Promise<boolean>
}

export type DialogsGlobal = {
  [name: string]: DialogApi
} & {
  $open: (name: string, options?: Parameters<DialogApi['open']>[0]) => Promise<void>
  $close: (...names: string[]) => Promise<void[]>
}

export const DialogPlugin = {
  install(app: App, options?: { mountKey?: string }) {
    const w = window as any
    const mountKey = options?.mountKey || '$dialogs'
    w.__dialogs = w.__dialogs || {}

    const dialogs: DialogsGlobal = Object.assign(w.__dialogs, {
      async $open(name: string, opt?: Parameters<DialogApi['open']>[0]) {
        const api: DialogApi | undefined = w.__dialogs[name]
        if (!api) throw new Error(`Dialog not found: ${name}`)
        return api.open(opt)
      },
      async $close(...names: string[]) {
        const tasks = names.map(n => {
          const api: DialogApi | undefined = w.__dialogs[n]
          return api ? api.close() : Promise.resolve()
        })
        return Promise.all(tasks)
      },
    })

    app.config.globalProperties[mountKey] = dialogs
    // 提供 inject 支持
    app.provide(mountKey, dialogs)
    w.__vue_app__ = app
  },
}

export default DialogPlugin
